export const RETURN_URL_QUERY_PARAM = 'returnUrl';

export const DEFAULT_POST_LOGIN_URL = '/';
